/**
 * MongoDB ObjectId validation utilities
 * Prevents GraphQL ID type errors by validating IDs are proper 24-char hex strings
 */

/**
 * Check if a value is a valid MongoDB ObjectId (24 character hex string)
 */
export const isValidMongoId = (id: string | undefined | null): boolean => {
    if (!id) return false;
    // MongoDB ObjectId: exactly 24 character hex string
    return /^[0-9a-f]{24}$/i.test(id);
};
